import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { BrowserModule } from "@angular/platform-browser";
// import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { DataTablesModule } from "angular-datatables";

import { LoginComponent } from "./components/login/login.component";
import { RecoverPasswordComponent } from "./components/recover-password/recover-password.component";
import { ChangePasswordComponent } from "./components/change-password/change-password.component";
import { ProfileComponent } from "./components/profile/profile.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { HeaderComponent } from "./components/header/header.component";
import { MenusComponent } from "./components/menus/menus.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ManualsComponent } from "./components/manuals/manuals.component";
import { SparePartDetailsComponent } from "./components/spare-part-details/spare-part-details.component";
import { ComplaintsListComponent } from "./components/complaints/complaints-list/complaints-list.component";
import { ComplaintsCreateComponent } from "./components/complaints/complaints-create/complaints-create.component";
import { ComplaintsViewComponent } from "./components/complaints/complaints-view/complaints-view.component";
import { ComplaintsHelpComponent } from "./components/complaints/complaints-help/complaints-help.component";
import { ChatFeatureComponent } from "./components/chat-feature/chat-feature.component";
import { CKEditorModule } from "ckeditor4-angular";
import { AuthGuard } from "./components/authguard/auth.guard";
import { UniqueEmailValidatorDirective } from "./components/profile/unique-email.directive";
import { ChartModule } from "angular2-chartjs";
import { NgApexchartsModule } from "ng-apexcharts";
import { AngularEditorModule } from '@kolkov/angular-editor';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [
    ProfileComponent,
    LoginComponent,
    RecoverPasswordComponent,
    ChangePasswordComponent,
    DashboardComponent,
    ChatFeatureComponent,
    HeaderComponent,
    MenusComponent,
    ManualsComponent,
    SparePartDetailsComponent,
    ComplaintsListComponent,
    ComplaintsCreateComponent,
    ComplaintsViewComponent,
    ComplaintsHelpComponent,
    UniqueEmailValidatorDirective,
  ],
  imports: [
    AngularEditorModule,
    CKEditorModule,
    DataTablesModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    ChartModule,
    NgApexchartsModule,
    NgbDropdownModule,
    RouterModule.forRoot([
      { path: "login", component: LoginComponent },
      { path: "recoverPassword", component: RecoverPasswordComponent },
      {
        path: "changePassword",
        component: ChangePasswordComponent,
      },
      {
        path: "dash",
        canActivate: [AuthGuard],
        component: DashboardComponent,
      },
      {
        path: "chat",
        canActivate: [AuthGuard],
        component: ChatFeatureComponent,
      },
      {
        path: "profile",
        canActivate: [AuthGuard],
        component: ProfileComponent,
      },
      {
        path: "manuals/:id",
        canActivate: [AuthGuard],
        component: ManualsComponent,
      },
      {
        path: "manuals/:id/:folderId",
        canActivate: [AuthGuard],
        component: ManualsComponent,
      },
      {
        path: "SparePartDetailsComponent/:id",
        canActivate: [AuthGuard],
        component: SparePartDetailsComponent,
      },
      {
        path: "ComplaintsList",
        canActivate: [AuthGuard],
        component: ComplaintsListComponent,
      },
      {
        path: "help",
        canActivate: [AuthGuard],
        component: ComplaintsHelpComponent,
      },
      {
        path: "ComplaintsCreate/Add",
        canActivate: [AuthGuard],
        component: ComplaintsCreateComponent,
      },
      {
        path: "ComplaintsCreate/Update:/id",
        canActivate: [AuthGuard],
        component: ComplaintsCreateComponent,
      },
      {
        path: "ComplaintsView/:id",
        canActivate: [AuthGuard],
        component: ComplaintsViewComponent,
      },
      { path: "**", redirectTo: "login" },
    ]),
  ],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
